import styled from '@emotion/styled';

export const LocationFormContainer = styled.div`
  .location-form {
    --bs-gutter-x: 48px;
  }

  .location-data {
    gap: 16px;
    margin-top: 16px;
    display: flex;
  }

  .form-buttons {
    display: flex;
    justify-content: end;
    margin: 8px 0;
  }

  .col-6 {
    padding-right: 24px;

    &:last-child {
      padding-left: 24px;
      padding-right: 0;
    }
  }
`;

export const LocationMapImageContainer = styled.div`
  width: 100%;
  height: 100%;
  max-height: 190px;
  border-radius: 8px;
  overflow: hidden;

  cursor: pointer;
`;

export const LocationMapImage = styled.img`
  height: 100%;
  width: 100%;
  object-fit: cover;
`;
